import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

function CarouselOsiris() {
  return (
    <div className="portfolioDentons">
      <h4 id="dentons">Print Design</h4>

      <Carousel className="carouselPrintDentons">
        <div>
          <img
            src="img/Print/01.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/02.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/03.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/04.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/05.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/06.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/07.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/08.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/09.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/10.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/11.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/12.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/13.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/14.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/15.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/16.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/17.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/18.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/19.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/20.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/21.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/22.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/23.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/24.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/25.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/26.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/27.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
        <div>
          <img
            src="img/Print/28.jpg"
            className="w-100 shadow-1-strong rounded mb-4"
            alt="Print design"
            id="imgCarousel"
          />
          <p className="legend">Print design</p>
        </div>
      </Carousel>
    </div>
  );
}

export default CarouselOsiris;
